import Ignite from "./Assets/Projects/ignite.png";
import Dindle from "./Assets/Projects/dindle.png";
import JustGold from "./Assets/Projects/justgold.png";
import Servicebuddy from "./Assets/Projects/ServiceBuddy.png";



export const PROJECTS = [
  {
    image: Dindle,
    name: "Dindle",
    deliverables: ["Mobile App", "Website"],
    technologyUsed: "React Native, TypeScript, Redux, GraphQL, Rocket.Chat, Jitsi",
    description:
      "All-in-one activity coordination for families and teams—plan events, assign tasks, chat, and share files. I built the mobile app and its companion website.",
    links: [
      { label: "App Store", url: "https://apps.apple.com/gb/app/dindle/id1548506219" },
      { label: "Website", url: "https://www.dindle.com/" },
    ],
  },
  {
    image: Servicebuddy,
    name: "ServiceBuddy",
    deliverables: ["Mobile App", "Website"],
    technologyUsed: "React Native, JavaScript, Redux, Stripe, Location Services",
    description:
      "Cloud-based field service management for teams on the go. I developed the mobile app and the client-facing website.",
    links: [
      { label: "App Store", url: "https://apps.apple.com/gb/app/service-buddy/id1263042090" },
    ],
  },
  {
    image: Ignite,
    name: "Ignite Manager",
    deliverables: ["Mobile App", "Website"],
    technologyUsed: "React Native, JavaScript, Redux-Saga, Keychain",
    description:
      "Offline-first POS for the Ignite commerce platform—any business can sell anything. I worked on the mobile app and product website.",
    links: [
      { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.ignitehq.app&hl=en" },
    ],
  },
  {
    image: JustGold,
    name: "Just Gold",
    deliverables: ["Mobile App", "Website"],
    technologyUsed: "React Native, JavaScript, Redux-Saga, Keychain",
    description:
      "Secure digital gold investment platform for buying, selling, and managing gold from a phone. I built the mobile app and marketing website.",
    links: [
      { label: "Play Store", url: "https://play.google.com/store/apps/details?id=com.justgold&pcampaignid=web_share" },
      { label: "Website", url: "https://justgold.app/" },
    ],
  },
];

export const ABOUT_HIGHLIGHTS = [
  { icon: "mobile", title: "Full Stack", detail: "Frontend, backend & mobile" },
  { icon: "rocket", title: "Ship Faster", detail: "Idea to production & app stores" },
  { icon: "chart", title: "Grow Revenue", detail: "UX, performance & conversions" },
  { icon: "globe", title: "Remote Ready", detail: "Dubai-based, global clients" },
];

export const ABOUT_SERVICES = [
  {
    title: "Websites & Web Apps",
    description: "High-converting sites and dashboards with React, Next.js, or Vue.js—built for speed, SEO, and user engagement.",
  },
  {
    title: "Cross-Platform Mobile Apps",
    description: "React Native apps that feel fast and native on iOS & Android, ready for App Store and Play Store launch.",
  },
  {
    title: "Backend & API Development",
    description: "Scalable Node.js and Express APIs, authentication, databases, and integrations that power your product reliably.",
  },
  {
    title: "Launch & Product Growth",
    description: "Deployment, performance tuning, UX fixes, and feature delivery to help existing products grow users and revenue.",
  },
];

export const TECH_STACK = [
  {
    category: "Frontend & Websites",
    clientValue: "Fast, modern sites that convert visitors",
    technologies: ["React", "Next.js", "Vue.js", "TypeScript", "Redux"],
  },
  {
    category: "Mobile Apps",
    clientValue: "One codebase for iOS & Android",
    technologies: ["React Native", "App Store", "Play Store"],
  },
  {
    category: "Backend & APIs",
    clientValue: "Secure server logic your app can trust",
    technologies: ["Node.js", "Express", "GraphQL", "REST APIs", "Firebase"],
  },
  {
    category: "Integrations & Payments",
    clientValue: "Connect tools and accept payments",
    technologies: ["Stripe", "Shopify", "Rocket.Chat", "Jitsi"],
  },
];
